
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 140 140","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(5.833333333333333,0,0,5.833333333333333,0,0)"}},[_c('defs',[_c('style',[_v('.a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}')])]),_c('title',[_v('ui-columns')]),_c('rect',{staticClass:"a",attrs:{"x":"0.75","y":"0.75","width":"22.5","height":"9","rx":"1.5","ry":"1.5"}}),_c('line',{staticClass:"a",attrs:{"x1":"3.75","y1":"3.75","x2":"11.022","y2":"3.75"}}),_c('line',{staticClass:"a",attrs:{"x1":"3.75","y1":"6.75","x2":"8.204","y2":"6.761"}}),_c('line',{staticClass:"a",attrs:{"x1":"15","y1":"0.75","x2":"15","y2":"9.75"}}),_c('polyline',{staticClass:"a",attrs:{"points":"19.5 3.75 18 5.25 19.5 6.75"}}),_c('rect',{staticClass:"a",attrs:{"x":"0.75","y":"14.25","width":"22.5","height":"9","rx":"1.5","ry":"1.5"}}),_c('line',{staticClass:"a",attrs:{"x1":"3.75","y1":"17.25","x2":"11.022","y2":"17.25"}}),_c('line',{staticClass:"a",attrs:{"x1":"3.75","y1":"20.25","x2":"8.204","y2":"20.261"}}),_c('line',{staticClass:"a",attrs:{"x1":"15","y1":"14.25","x2":"15","y2":"23.25"}}),_c('polyline',{staticClass:"a",attrs:{"points":"19.5 17.25 18 18.75 19.5 20.25"}})])])
          )
        }
      }
    